/**
 * Height Calculator Module
 * Handles all height-related calculations
 */
export class HeightCalculator {
  constructor(options) {
    this.config = options
  }

  calculateTotalHeight(height) {
    return height * 2 - 300
  }

  calculateHeights(h1, h3) {
    if (isNaN(h3)) {
      return { opening: 0, transom: 0, total: 0 }
    }

    const x = h1 - 315 // opening height
    const y = h3 - h1 - x // transom height

    return {
      opening: x,
      transom: y,
      total: h3
    }
  }

  calculateSplitHeights(h1, h3) {
    if (isNaN(h1) || isNaN(h3)) {
      return { opening: 0, transom: 0, total: 0 }
    }

    // Calculate opening height (x)
    const x = Math.floor(((h3 - h1 - 51) * 2) / 3)

    // Calculate transom height (y)
    const y = h3 - h1 - x

    return {
      opening: x,
      transom: y,
      total: h3
    }
  }
}
